import { render, staticRenderFns } from "./VerificationCode.vue?vue&type=template&id=7ae68d2a&scoped=true"
import script from "./VerificationCode.vue?vue&type=script&lang=js"
export * from "./VerificationCode.vue?vue&type=script&lang=js"
import style0 from "./VerificationCode.vue?vue&type=style&index=0&id=7ae68d2a&prod&lang=scss&scoped=true"
import style1 from "./VerificationCode.vue?vue&type=style&index=1&id=7ae68d2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae68d2a",
  null
  
)

export default component.exports